import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PolicyDetailComponent } from '../policy-detail.component'
// Service
import { InsurancePolicyService } from 'src/app/core/services/actors/insurancePolicy.service';
@Component({
    selector: 'detail-modal',
    templateUrl: './detail-modal.component.html',
  })
  export class DetailModal implements OnInit {

    ranges = [];
    isHighRisk = false;

    constructor(
      private insurancePolicyService: InsurancePolicyService,
      public dialogRef: MatDialogRef<PolicyDetailComponent>,
      @Inject(MAT_DIALOG_DATA) public data,
    ) {}

    ngOnInit(): void {
      this.insurancePolicyService.getPolicyDetailsById(this.data.motherId).subscribe(_res => {
        this.ranges = _res.rangeList;
      })
    }

    onNoClick(refresh): void {
      this.dialogRef.close(refresh);
    }

    formatType(type) {
      switch (type) {
        case 'HIGH_RISK':
          return 'Alto riesgo';
        case 'SPECIAL':
          return 'Especial';
        case 'PREFERENT':
          return 'Preferente';
        default:
          return type
      }
    }

    formatCurrency(value) {
      const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
      const newValue = formatter.format(value)
      return newValue.slice(0, newValue.length - 3)
    }

  isHigthRisk(description: (() => string) | string | undefined) {
    this.isHighRisk = !(description === 'HIGH_RISK' || description === 'Alto riesgo');
      return this.isHighRisk;
  }
}
